import React from "react";
import { Nav, Container, Breadcrumb, Spinner } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import Emitter from "services/Emitter";
import ProcessingButton from "components/ProcessingButton";
import URLVerificationTab from "./URLVerificationTab";
import URLVerificationService from "services/URLVerificationService";
import Toast from "services/Toast";
import {
    COUNT_EVENTS,
    EXPORT_EVENTS,
    REFRESH_EVENTS,
} from "./URLVerificationConfig";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: {
                unset: { total: 0, items: [] },
                approved: { total: 0, items: [] },
                rejected: { total: 0, items: [] },
            },
            tabs: {
                "#action_required": {
                    key: 0,
                    title: "Action Required",
                    countEvent: COUNT_EVENTS.ACTION_REQUIRED,
                    exportEvent: EXPORT_EVENTS.ACTION_REQUIRED,
                    tableName: "url-verification-action-required",
                    statusKey: "unset",
                    count: 0,
                },
                "#approved": {
                    key: 1,
                    title: "Approved",
                    countEvent: COUNT_EVENTS.APPROVED,
                    exportEvent: EXPORT_EVENTS.APPROVED,
                    tableName: "url-verification-approved",
                    statusKey: "approved",
                    count: 0,
                },
                "#rejected": {
                    key: 2,
                    title: "Rejected",
                    countEvent: COUNT_EVENTS.REJECTED,
                    exportEvent: EXPORT_EVENTS.REJECTED,
                    tableName: "url-verification-rejected",
                    statusKey: "rejected",
                    count: 0,
                },
            },
        };
        this.updateCount = this.updateCount.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.loadAllData = this.loadAllData.bind(this);
    }

    async loadAllData() {
        const data = await URLVerificationService.getAll();
        if (data === false) {
            Toast.error("Something went wrong while loading the data");
            this.setState({ loading: false });
            return;
        }
        this.setState(
            {
                loading: false,
                data: {
                    unset: data.unset ?? { total: 0, items: [] },
                    approved: data.approved ?? { total: 0, items: [] },
                    rejected: data.rejected ?? { total: 0, items: [] },
                },
            },
            () => {
                this.updateCount("#action_required", data.unset?.total || 0);
                this.updateCount("#approved", data.approved?.total || 0);
                this.updateCount("#rejected", data.rejected?.total || 0);
            }
        );
    }

    getActiveTab() {
        const match = window.location.href.match(/#\w+/);
        return match !== null &&
            typeof this.state.tabs[match[0]] !== "undefined"
            ? match[0]
            : "#action_required";
    }

    handleExport() {
        const activeTab = this.getActiveTab();
        const { exportEvent } = this.state.tabs[activeTab];
        Emitter.emit(exportEvent);
    }

    componentDidMount() {
        Emitter.on(COUNT_EVENTS.ACTION_REQUIRED, (count) =>
            this.updateCount("#action_required", count)
        );
        Emitter.on(COUNT_EVENTS.APPROVED, (count) =>
            this.updateCount("#approved", count)
        );
        Emitter.on(COUNT_EVENTS.REJECTED, (count) =>
            this.updateCount("#rejected", count)
        );
        Emitter.on(REFRESH_EVENTS.ALL, this.loadAllData);
        this.loadAllData();
    }

    componentWillUnmount() {
        Emitter.off(COUNT_EVENTS.ACTION_REQUIRED);
        Emitter.off(COUNT_EVENTS.APPROVED);
        Emitter.off(COUNT_EVENTS.REJECTED);
        Emitter.off(REFRESH_EVENTS.ALL);
    }

    updateCount(tabKey, count) {
        this.setState((prevState) => ({
            tabs: {
                ...prevState.tabs,
                [tabKey]: {
                    ...prevState.tabs[tabKey],
                    count,
                },
            },
        }));
    }

    showPage(tab) {
        const { tableName, statusKey, countEvent, exportEvent } =
            this.state.tabs[tab];
        const tabData = this.state.data[statusKey] ?? { total: 0, items: [] };
        return (
            <URLVerificationTab
                name={tableName}
                countEvent={countEvent}
                exportEvent={exportEvent}
                data={tabData}
                onRefresh={this.loadAllData}
            />
        );
    }

    render() {
        const tabs = Object.keys(this.state.tabs);
        const activeKey = this.getActiveTab();

        return (
            <Container className="pt-4">
                <Breadcrumb className="dd">
                    <Breadcrumb.Item>Diagnostics</Breadcrumb.Item>
                    <Breadcrumb.Item active>URL Verification</Breadcrumb.Item>
                </Breadcrumb>
                <div
                    className="d-flex justify-content-between align-items-end"
                    style={{ borderBottom: "1px solid #dee2e6" }}
                >
                    <Nav
                        variant="tabs"
                        activeKey={activeKey}
                        style={{ borderBottom: "none", marginBottom: "-1px" }}
                    >
                        {tabs.map((tab) => {
                            const { title, key, count } = this.state.tabs[tab];
                            return (
                                <Nav.Item key={key}>
                                    <Nav.Link href={tab}>
                                        {title} ({count})
                                    </Nav.Link>
                                </Nav.Item>
                            );
                        })}
                    </Nav>
                    <ProcessingButton
                        size="sm"
                        processing={false}
                        processingLabel="Downloading..."
                        variant="success"
                        label="Download CSV"
                        icon={faDownload}
                        onClick={this.handleExport}
                        style={{ marginBottom: "8px" }}
                    />
                </div>
                {this.state.loading ? (
                    <div className="d-flex justify-content-center py-5">
                        <Spinner animation="border" role="status" />
                    </div>
                ) : (
                    this.showPage(activeKey)
                )}
            </Container>
        );
    }
}

export default withRouter(Index);
